import { t } from "@/i18n-js/instance";

export const TABS = {
  DETAILS: t("settings.paywall_coupons.tabs.details"),
  PAYWALLS: t("settings.paywall_coupons.tabs.paywalls"),
  USAGE: t("settings.paywall_coupons.tabs.usage"),
};
